import { Body, Box, Button, Heading, Icon } from '@hover/blueprint';
import { iAlertCircle } from '@hover/icons';
import React from 'react';

import { PAYMENT_BANNER_EVENT_NAMES } from 'src/shared/components/PaymentBanner/types';
import { PaymentBannerKinds } from 'src/shared/graphql/generated';
import {
  TranslationNamespace,
  useCurrentPage,
  useTranslate,
} from 'src/shared/hooks';
import { External } from 'src/shared/route';
import { buttonPressed } from 'src/shared/telemetry';

import type { PaymentBannerProps } from './types';

const COLORS = {
  [PaymentBannerKinds.Trial]: 'warning',
  [PaymentBannerKinds.Expired]: 'danger',
};

export const PaymentBannerV1: React.FC<PaymentBannerProps> = ({ details }) => {
  const kind =
    details.kind === PaymentBannerKinds.Expiring
      ? PaymentBannerKinds.Trial
      : details.kind;
  const t = useTranslate(TranslationNamespace.PROPERTY_DETAILS);
  const currentPage = useCurrentPage();

  return (
    <Box
      backgroundColor={`${COLORS[kind]}.100`}
      px={{ base: '24px', mobile: '16px' }}
    >
      <Box
        alignContent="center"
        alignItems="center"
        flex={1}
        justifyContent="space-between"
        marginX="auto"
        marginY={300}
        maxWidth={760}
      >
        <Icon
          color={`${COLORS[kind]}.500`}
          icon={iAlertCircle}
          margin={0}
          marginRight="300"
          minHeight="40px"
          minWidth="40px"
          size="large"
        />
        <Box flex={1} flexWrap="wrap" gap={200} justifyContent="flex-start">
          <Box flex={1} flexBasis={{ base: '100%', tablet: 'auto' }}>
            <Box flexDirection="column">
              <Heading
                marginBottom="0 !important"
                size={300}
                textColor="neutral.900"
              >
                {details.title}
              </Heading>
              <Body m={0} size={{ desktop: 400, mobile: 300 }}>
                {details.body}
              </Body>
            </Box>
          </Box>
          <Button
            as="a"
            colorMode="dark"
            fontSize={{ desktop: 300, mobile: 100 }}
            href={External.PAYMENTS.path}
            onClick={() =>
              buttonPressed({
                page_or_screen_name: currentPage ?? '',
                primary_cta: true,
                button_text: 'Add payment',
                feature: `${PAYMENT_BANNER_EVENT_NAMES[kind]} credit card banner v1`,
              })
            }
            variant="primary"
          >
            {t('paymentBanner.CTALabel')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
